/* Collection-only Flat Lay / On Model view. Reconnects after Prestige facet updates. */
(() => {
  if (customElements.get('gc-collection-view')) return;

  const storageKey = 'gc:collection-image-view:v1';
  let selectedView = 'product';
  try {
    if (sessionStorage.getItem(storageKey) === 'model') selectedView = 'model';
  } catch (_) { /* The view still works when browser storage is unavailable. */ }

  class CollectionView extends HTMLElement {
    connectedCallback() {
      this.abortController?.abort();
      this.abortController = new AbortController();
      const { signal } = this.abortController;
      this.addEventListener('click', (event) => {
        const button = event.target.closest('[data-gc-view]');
        if (!button || !this.contains(button)) return;
        const view = button.dataset.gcView;
        if (view !== 'product' && view !== 'model') return;
        selectedView = view;
        try { sessionStorage.setItem(storageKey, view); } catch (_) {}
        this.setView(view, true);
      }, { signal });

      // Also runs when Shopify replaces the collection section after a filter/page change.
      queueMicrotask(() => {
        if (!this.isConnected || signal.aborted) return;
        this.setView(selectedView);
        this.querySelector('.gc-view-toggle')?.removeAttribute('hidden');
      });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    setView(view, announce = false) {
      this.dataset.view = view;
      this.querySelectorAll('[data-gc-view]').forEach((button) => {
        button.setAttribute('aria-pressed', String(button.dataset.gcView === view));
      });
      this.querySelectorAll('.product-card__media').forEach((media) => {
        const template = media.querySelector('template[data-gc-model-image]');
        let model = media.querySelector('.gc-model-image');
        if (view === 'model' && template && !model) {
          // Inert templates avoid downloading a second catalog of images on initial load.
          const fragment = template.content.cloneNode(true);
          model = fragment.querySelector('img');
          if (model) {
            model.addEventListener('load', () => {
              media.classList.add('gc-model-ready');
              this.updateImageAccessibility(media);
            });
            model.addEventListener('error', () => {
              media.classList.remove('gc-model-ready');
              this.updateImageAccessibility(media);
            });
            media.append(fragment);
            if (model.complete && model.naturalWidth > 0) media.classList.add('gc-model-ready');
          }
        }
        this.updateImageAccessibility(media);
      });
      if (announce) {
        const status = this.querySelector('[data-gc-view-status]');
        if (status) status.textContent = status.dataset[`${view}Message`];
      }
    }

    updateImageAccessibility(media) {
      const showingModel = this.dataset.view === 'model' && media.classList.contains('gc-model-ready');
      media.querySelector('.product-card__image--primary')?.setAttribute('aria-hidden', String(showingModel));
      media.querySelector('.gc-model-image')?.setAttribute('aria-hidden', String(!showingModel));
    }
  }

  customElements.define('gc-collection-view', CollectionView);
})();
